export const splitShellStyle = {
  display: 'inline-flex',
  alignItems: 'stretch',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  borderRadius: 999,
  background: '#3c4043',
};

export const splitActionColors = {
  off: '#ea4335',
  hover: '#4a4d51',
  idle: 'transparent',
  text: '#ffffff',
};

const splitMainButtonBaseStyle = {
  height: 44,
  minWidth: 44,
  borderTopLeftRadius: 999,
  borderBottomLeftRadius: 999,
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  border: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
};

export const getSplitMainButtonStyle = ({
  off,
  hovered,
  width = 44,
  minWidth = width,
}) => ({
  ...splitMainButtonBaseStyle,
  width,
  minWidth,
  background: off
    ? splitActionColors.off
    : (hovered ? splitActionColors.hover : splitActionColors.idle),
  color: splitActionColors.text,
});

export const splitWrapStyle = {
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0,
  zIndex: 61,
};

export const deviceMenuStyle = {
  position: 'absolute',
  bottom: 'calc(100% + 8px)',
  right: 0,
  minWidth: 220,
  width: 'min(360px, calc(100vw - 24px))',
  background: 'rgba(32, 33, 36, 0.98)',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  borderRadius: 14,
  padding: 8,
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  maxWidth: 'min(360px, calc(100vw - 24px))',
  boxShadow: '0 14px 30px rgba(0, 0, 0, 0.34)',
  zIndex: 120,
  overflow: 'hidden',
};

export const deviceMenuItemStyle = (active) => ({
  width: '100%',
  border: 'none',
  background: active ? 'rgba(46, 170, 199, 0.22)' : 'transparent',
  color: active ? '#b9f2ff' : '#f1f3f4',
  textAlign: 'left',
  fontSize: 12,
  fontWeight: active ? 600 : 500,
  padding: '10px 12px',
  borderRadius: 10,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
  lineHeight: 1.3,
});

export const audioMenuSectionStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
};

export const audioMenuSectionTitleStyle = {
  color: '#c8d2dc',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 0.02,
  textTransform: 'uppercase',
  padding: '4px 6px 2px 6px',
};

export const audioMenuDividerStyle = {
  width: '100%',
  height: 1,
  background: 'rgba(255, 255, 255, 0.08)',
  margin: '2px 0',
};

export const audioMenuTestButtonStyle = {
  width: '100%',
  border: '1px solid rgba(143, 230, 251, 0.42)',
  background: 'rgba(46, 170, 199, 0.12)',
  color: '#d6f6ff',
  textAlign: 'center',
  fontSize: 12,
  fontWeight: 700,
  padding: '10px 12px',
  borderRadius: 10,
  cursor: 'pointer',
};

export const getMoreButtonStyle = (hovered) => ({
  width: 22,
  height: 44,
  border: 'none',
  borderLeft: '1px solid rgba(255, 255, 255, 0.12)',
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderTopRightRadius: 999,
  borderBottomRightRadius: 999,
  background: hovered ? splitActionColors.hover : splitActionColors.idle,
  color: splitActionColors.text,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: 0,
});
